import { motion, AnimatePresence } from "framer-motion";
import { FormattedMessage } from "react-intl";
import { Button } from "./button";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  titleKey: string;
  messageKey: string;
  confirmButtonTextKey: string;
  cancelButtonTextKey?: string;
  onCancel?: () => void;
}

export default function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  titleKey,
  messageKey,
  confirmButtonTextKey,
  cancelButtonTextKey = "common.cancel",
  onCancel,
}: ConfirmationModalProps) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 bg-modal/80 flex items-center justify-center z-50"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-xl p-5 max-w-sm w-full mx-5 space-y-6.5"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-3">
              <h1 className="font-medium text-dark ">
                <FormattedMessage id={titleKey} />
              </h1>
              <p className="text-body text-dark-gray">
                <FormattedMessage id={messageKey} />
              </p>
            </div>
            <div className="flex gap-3">
              <Button
                className="w-full"
                variant="secondary"
                onClick={handleCancel}
              >
                <FormattedMessage id={cancelButtonTextKey} />
              </Button>
              <Button className="w-full" onClick={handleConfirm}>
                <FormattedMessage id={confirmButtonTextKey} />
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
